import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit, ElementRef } from '@angular/core';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { EducationService } from '../../services/education.service';
import { ReportsService } from '../../services/reports.service';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, ValidationErrors, FormControl, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { PrintService } from '../../services/print.service'
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-attendees',
	templateUrl: './attendees.component.html',
	styleUrls: ['./attendees.component.scss']
})
export class AttendeesComponent implements OnInit{
	@ViewChild('attendees') attendeeRef: ElementRef;
	@ViewChild('emailbox') emailRef: ElementRef;
	@ViewChild('print_table', { static: false }) printtablepdf: ElementRef;
	color: any = 'blue';
	programs: any = [];
	searchForm: UntypedFormGroup;
	emailAddr = new UntypedFormControl('');
	reportResults: any = [];
	sending: any = false;
	loading: any = false;
	totals: any = [];
	sortedReportResults: any = [];
	sortByColumn: string;
	sortDirection: string;
	events: any = [];
	hosts: any = [];
	cities: any = [];
	salespeople: any = [];
	years: any = [];
	selected_event: any = [];
	email_event: any = false;
	attendeeForm: UntypedFormGroup;
	
	constructor(private _changeDetectorRef: ChangeDetectorRef, private fb: UntypedFormBuilder, private modalService: NgbModal, private reportsService: ReportsService, private educationService: EducationService, private globalSearchService: GlobalSearchService,  private printService: PrintService) {
		this.color = this.globalSearchService.getColor();
		
	}
	
	ngOnInit(){
		this.educationService.getRewards().subscribe((r) => {
			this.programs = r;
		});
		this.educationService.getCities().subscribe((r) => {
			this.cities = r;
		});
		this.educationService.getHosts().subscribe((r) => {
			this.hosts = r;
		});
		this.educationService.getEvents().subscribe((r) => {
			this.events = r;
		});
		this.educationService.getYears().subscribe((r) => {
			this.years = r;
		});
		this.reportsService.getSalesPeople().subscribe((results: any) => {
			this.salespeople = results;
		});
		
		this.searchForm = this.fb.group({
			'city': [],
			'salesperson':[],
			'year':[],
			'host':[],
			'status':[],
			'startdate': ['', Validators.required],
			'enddate':['', Validators.required],
			'event': [],
		});
		this.search();
	}
	search(){
	
	
		this.educationService.getSearch(this.searchForm.value).subscribe((results: any) => {
			this.sortedReportResults = results.results;
		});
	}
	
	exportPdf() {

		if (!this.printtablepdf) {
		  console.error('Print table element not found');
		  return;
		}
		
		const d = new Date();
		this.sending = true;
		const encoded = this.globalSearchService.base64encode(this.printtablepdf.nativeElement.innerHTML);
		
		const data = {
		  content: encoded,
		  filename: 'event_listing',
		  title: `Event Listing -  ${d.toLocaleString()}`,
		};

	  
		this.printService.pdf(data).subscribe((result: any) => {
		  this.globalSearchService.downloadPdf(result.content, data.filename);
		  this.sending = false;
		});
	  }

	exportXls() {

		if (!this.printtablepdf) {
			console.error('Print table element not found');
			return;
		}
		const d = new Date();
		this.sending = true;
		const encoded = this.globalSearchService.base64encode(this.printtablepdf.nativeElement.innerHTML);

		const data = {
			content: encoded,
			filename: 'event_listing',
			title: `Event Listing -  ${d.toLocaleString()}`
		};

		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.sending = false;
		});
	}
	saveChanges(){
		const data = { registrants: this.attendeeForm.value, history_id: this.selected_event.history_id };
		this.educationService.updateReg(data).subscribe((results: any) => {
			this.sortedReportResults = results.results;
			this.modalService.dismissAll();
		});
	}
	prepEmail(event: any){
	this.email_event = event;
	this.emailAddr.setValue('');
	this.modalService.open(this.emailRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {
				
			}, (reason) => {
			});
	}
	sendEmail(){
		const data = {id: this.email_event.history_id, debtor: this.email_event.customerid, email: this.emailAddr.value};
		this.educationService.emailReceipt(data).subscribe((a) => {
			if(a.error != ''){
			this.globalSearchService.showNotification(
						a.error,
						'danger',
						'bottom',
						'right'
					);
			} else {
			this.globalSearchService.showNotification(
						'Email Sent',
						'success',
						'bottom',
						'right'
					);
			}
		});
	}
	viewAttendees(event: any) {
		const data = { 'debtor': event.customerid, 'id': event.history_id };
		this.educationService.getHistoryData(data).subscribe((a) => {
			this.selected_event = a;
			this.attendeeForm = this.fb.group({
				notes: [this.selected_event.history.notes],
			});
			this.selected_event.history.registrants.forEach((m) => {
				
				this.attendeeForm.addControl('name-'+m.id, new UntypedFormControl(m.name,[]));
				this.attendeeForm.addControl('phone-'+m.id, new UntypedFormControl(m.phone,[]));
				this.attendeeForm.addControl('email-'+m.id, new UntypedFormControl(m.email,[]));
				
			});
			this.modalService.open(this.attendeeRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {
				
			}, (reason) => {
				this.search();
			});
		});
	}
	removeReg(name: any, historyid: number) {

		if (confirm('Are you sure you want to remove this registration?')) {
			const data = {
				registrationId: historyid,
				eventId: historyid,
				name: name,
				order_id: name
			};

			this.educationService.removeAtendee(data).subscribe({
				next: (response) => {
					this.selected_event = response;
					this.globalSearchService.showNotification(
						'Registration successfully removed',
						'success',
						'bottom',
						'right'
					);
				},
				error: (error) => {
					this.globalSearchService.showNotification(
						'Error removing registration',
						'danger',
						'bottom',
						'right'
					);
				}
			});
		}
	}
	
	removeAllReg(historyid: any){
		if (confirm('Are you sure you want to remove this registration?')) {
			const data = {
				registrationId: historyid
			};

			this.educationService.removeRegistration(data).subscribe({
				next: (response) => {
					this.search();
					this.globalSearchService.showNotification(
						'Registration successfully removed',
						'success',
						'bottom',
						'right'
					);
				},
				error: (error) => {
					this.globalSearchService.showNotification(
						'Error removing registration',
						'danger',
						'bottom',
						'right'
					);
				}
			});
		}
	
	}
}
